import React, {useContext, useEffect, useReducer} from 'react'
import { FilterContext } from './FilterContext'
import {AUTH_LOGIN, FILTER_ACTION, SEARCH_INITIAL_FILTER} from '../../constant'
import { UserContext } from '../index'

const filterReducer = (state, action) => {
	switch (action.type){
		case FILTER_ACTION.SET_FILTER: {
			return {
				...state,
				...action.payload
			}
		}
		case FILTER_ACTION.RESET_FILTER: {
			return action.payload
		}
		default: {
			return state
		}
	}
}

export function FilterProvider({children}){
	const {user} = useContext(UserContext)
	const initialState = {...SEARCH_INITIAL_FILTER, ...{list_ids_arr: user.categories}}
	const [filter, dispatch] = useReducer(filterReducer, initialState)

	useEffect(() => {
		if (user.auth === AUTH_LOGIN) {
			dispatch({type: FILTER_ACTION.SET_FILTER, payload: {list_ids_arr: user.categories}})
		}
	}, [user.categories])

	return <FilterContext.Provider value={{
		filter,
		setFilter: (params) => dispatch({type: FILTER_ACTION.SET_FILTER, payload: params}),
		resetFilter: () => dispatch({type: FILTER_ACTION.SET_FILTER, payload: initialState}),
	}}>{children}</FilterContext.Provider>
}